'use strict';

wbApp.controller('SubjectsCtrl', ['$scope', '$modal', 'subjectsSvc', 'tenantInfo',
function ($scope, $modal, subjectsSvc, tenantInfo) {

    $scope.isFranchise = !!_.find(tenantInfo.franchiseCentrals, { isActive: true, supportSubjectLicenses: true });
    $scope.isFranchiseCentral = tenantInfo.isFranchiseCentral;

    $scope.filterOptions = {
        filterText: ""
    };

    if ($scope.isFranchise) {
        $scope.gridOptions = {
            sortInfo: { fields: ['name'], directions: ['dsc'] },
            columnDefs: [{ field: 'franchiseCentralTenantID', displayName: "TXT_LBL_FRANCHISE", cellFilter: 'franchiseCentralFlt', width: '90px' },
                         { field: 'name', displayName: "TXT_LBL_NAME", sort: 'locale', width: '270px' },                         
                         { field: 'description', displayName: "TXT_LBL_DESCRIPTION", sort: 'locale' }
            ],
            disabledField: 'franchiseCentralTenantID',
            disabledAreSelectable: true
        };
    } else {
        $scope.gridOptions = {
            sortInfo: { fields: ['name'], directions: ['dsc'] },
            columnDefs: [{ field: 'name', displayName: "TXT_LBL_NAME", sort: 'locale', width: '270px' },
                         { field: 'description', displayName: "TXT_LBL_DESCRIPTION", sort: 'locale' }
            ],
            disabledField: 'franchiseCentralTenantID',
            disabledAreSelectable: true
        };
    }

    function setSelectedSubject(subject) {
        $scope.selectedSubject = subject;
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.subjects = subjectsSvc.getAllForCoursesAsync(true);
        setSelectedSubject(null);
    });

    $scope.subjects = subjectsSvc.getAllForCoursesAsync(true);

    $scope.selectedSubject = {};

    $scope.onRowSelected = function (data) {
        setSelectedSubject(data);
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = subjectsSvc.createNew();
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        subjectsSvc.remove(data);
    }

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "courses/subjects-detail-tabs/detail.html"
    }];

    $scope.tabs.activeTab = 0;


    var detailDialogPromise = $modal({
        templateUrl: 'courses/subjects-detail.html',
        show: false,        
        scope: $scope.$new()
    });

}]);
